import React, { useState } from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { TripSpotlight } from './components/TripSpotlight';
import { AboutConcept } from './components/AboutConcept';
import { Team } from './components/Team';
import { ConfirmedModels } from './components/ConfirmedModels';
import { WhoCanJoin } from './components/WhoCanJoin';
import { Benefits } from './components/Benefits';
import { DestinationGallery } from './components/DestinationGallery';
import { ApplicationForm } from './components/ApplicationForm';
import { UpcomingDestinations } from './components/UpcomingDestinations';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { Impressum } from './components/Impressum';
import { CookieBanner } from './components/CookieBanner';
export function App() {
  const [showImpressum, setShowImpressum] = useState(false);
  return <div className="relative min-h-screen bg-white text-[#1a1a2e] selection:bg-brand-accent/20 selection:text-brand-accent" data-id="element-0">
      <div className="fixed inset-0 z-50 pointer-events-none bg-noise mix-blend-multiply" data-id="element-1"></div>

      <Navigation data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <TripSpotlight data-id="element-5" />
        <AboutConcept data-id="element-6" />
        <Team data-id="element-7" />
        <ConfirmedModels data-id="element-8" />
        <WhoCanJoin data-id="element-9" />
        <Benefits data-id="element-10" />
        <DestinationGallery data-id="element-11" />
        <ApplicationForm data-id="element-12" />
        <UpcomingDestinations data-id="element-13" />
        <FAQ data-id="element-14" />
      </main>

      <Footer onOpenImpressum={() => setShowImpressum(true)} data-id="element-15" />

      <Impressum isOpen={showImpressum} onClose={() => setShowImpressum(false)} data-id="element-16" />
      <CookieBanner data-id="element-17" />
    </div>;
}